export enum enumIdentType {
    idType_Unknown = 0,
    idType_DriversLicense = 1,
    idType_Passport = 3,
    idType_VendorID = 6,
    idType_NationalInsurance = 7,
    idType_BCD = 8,
    idType_BCN = 9,
    idType_PerfectDrive = 10,
    idType_FrequentFlyer = 11,
    idType_AccountNumber = 12,
    idType_BudgetChargeCard = 14,
    idType_EuropcarOneTripTravel = 15,
    idType_Visa = 16,
    idType_MasterCard = 17,
    idType_AmericanExpress = 18,
    idType_Diners = 19,
    idType_ConfidentialMasterAccount = 20,
    idType_ForceCharge = 21,
    idType_Cash = 22,
    idType_Cheque = 23,
    idType_VATNumber = 24,
    idType_FullCredit = 25,
    idType_LimitedValueVoucher = 26,
    idType_LimitedDaysVoucher = 27,
    idType_GeneralCreditCard = 28,
    idType_InsurancePolicy = 29,
    idType_CompanyVisa = 30,
    idType_ChargeCard = 31,
    idType_Currency = 32,
    idType_Voucher = 33,
    idType_GeneralID = 34,
    idType_ProvisionalPayments = 35,
    idType_Reward = 36,
    idType_Email = 37,
    idType_StoreCard = 38,
    idType_Switch = 39,
    idType_IATANumber = 40,
    idType_AccountID = 41,
    idType_BudgetPrepaidVoucher = 42,
    idType_CompanyAmex = 43,
    idType_CompanyMastercard = 44,
    idType_CompanyDiners = 45,
    idType_CompanyVoucher = 46,
    idType_CorpID = 47,
    idType_UtilityBill = 48,
    idType_NilValueVoucher = 49,
    idType_Optimum = 50,
    idType_LocalAccount = 51,
    idType_LegacyCustomerNumber = 52,
    idType_CarRentalVoucher = 53,
    idType_SAAMultiPurposeDocument = 54,
    idType_CompanyID = 55,
    idType_Local = 56,
    idType_Voucher2 = 57,
    idType_ProvisionalClose = 58,
    idType_LimitedCreditAdjustment = 59,
    idType_LocalAccountNett = 60,
    idType_SecondVisa = 61,
    idType_PlatinumChargeCard = 62,
    idType_ChabadPlatinumChargeCard = 63,
    idType_EuropcarChargeCardOrdinary = 64,
    idType_ReadyServiceVoucher = 65,
    idType_EuropcarExchangeOrder = 66,
    idType_MileageVoucher = 67,
    idType_FuelVoucher = 68,
    idType_SouthAfricanID = 69,
    idType_ReferralCommissionNumber = 70,
    idType_GlobalDriverID = 71,
    idType_UniquePINNumber = 72,
    idType_PseudoCityCode = 73,
    idType_IODDriveCard = 74,
    idType_DirectorsDriveCard = 75,
    idType_DriveCard = 76,
    idType_ReadyCard = 77,
    idType_EuropcarPrivilegeCard = 78,
    idType_BusinessEmail = 79,
    idType_InvoiceEmail = 80,
    idType_InsuranceVoucher = 82,
    idType_ConfidentialLocalAccount = 83,
    idType_InsuranceCompanyVoucher = 84,
    idType_Discover = 85,
    idType_BlueChip = 86,
    idType_FrequentRenterID = 87,
    idType_AuthorisedBill = 88,
    idType_PrivateInvoice = 89,
    idType_MedicareCard = 90,
    idType_EFTPOS = 91,
    idType_EmployeeNumber = 92,
    idType_AutoClub = 93,
    idType_JCB = 94,
    idType_TIDS = 95,
    idType_ABN = 96,
    idType_VehicleReplacementVoucher = 97,
    idType_SalesmanCode = 98,
    idType_WOAG = 99,
    idType_FinancialAccountNumber = 100,
    idType_VisaDebit = 101,
    idType_MastercardDebit = 102,
    idType_AmexDebit = 103,
    idType_PersBankAccount = 104,
    idType_CoBankAccount = 105,
    idType_CoRegNumber = 106,
    idType_SecondConfidentialLocalAccount = 115,
    idType_LimitedCreditPrepay = 116,
    idType_EuropcarCentralBillChargeCard = 117,
    idType_EuropcarDirectBillChargeCard = 118,
    idType_ResCentreNotificationProfileName = 199,
    idType_CorporateMembership = 120,
    idType_BrokerFCV = 121,
    idType_BrokerLCA = 122,
    idType_BrokerLCV = 123,
    idType_AuthorisedRep = 124,
    idType_JMBG = 125,
    idType_BankTransfer = 126,
    idType_CompanyBankTransfer = 127,
    idType_AgentBankTransfer = 128,
}

export enum enumIdentStatus {
    idStatus_Unknown = 0,
    idStatus_Valid = 1,
    idStatus_Blacklisted = 2,
    idStatus_Suspended = 3,
    idStatus_Deleted = 4,
}

export class Identification {
    public identId:             number;
    public identType:           enumIdentType;
    public identTypeDesc:       string;
    public identStatus:         enumIdentStatus;
    public membershipNumber:    string;
    public allowNotification:   boolean;
    public notify:              boolean;
    public expiry?:             Date;
}
